import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateSmsComponent } from './create-sms.component';
import { SendTestSmsComponent } from './send-test-sms.component';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { MaterialChipsInputModule } from '../tags/materialChipsInput.module';
import { TranslatePipeModule } from '../../translate/translate.pipe.module';
import { NgxSelectModule } from 'ngx-select-ex';
import {ControlMessageModule} from '../../control-message/control-message.module';
import {GenericModalModule} from '../../modal/generic-modal.module';

@NgModule({
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule, MaterialChipsInputModule, TranslatePipeModule, NgxSelectModule, ControlMessageModule, GenericModalModule
    ],
  declarations: [
    CreateSmsComponent,
    SendTestSmsComponent
  ],
  providers: [],
  exports: [ CreateSmsComponent,SendTestSmsComponent ]
})
export class SmsModule {

}
